import { ImportInternationalCustomsCsvResult } from "@redotech/redo-model/inventory/international-customs-upload";
import * as z from "zod/v4";

export const ImportInternationalCustomsCsvStatus = z.enum([
  "running",
  "completed",
  "failed",
  "not_found",
]);
export type ImportInternationalCustomsCsvStatus = z.infer<
  typeof ImportInternationalCustomsCsvStatus
>;

export const getImportInternationalCustomsCsvStatus = {
  name: "getImportInternationalCustomsCsvStatus" as const,
  input: z.object({ workflowId: z.string() }),
  output: z.object({
    status: ImportInternationalCustomsCsvStatus,
    failureMessage: z.string().optional(),
    result: ImportInternationalCustomsCsvResult.optional(),
  }),
};
